import { gql } from "@apollo/client";
import { PolicyVehicleExemptionSummary, policyVehicleExemptionSummaryFragment } from "../fragments";

export const START_VEHICLE_EXEMPTION = gql`
  mutation StartVehicleExemption(
    $licensePlateNumber: String!
    $licensePlateRegion: String!
    $beginAt: timestamptz!
    $vehicleDescription: String
  ) {
    startPolicyVehicleExemption: start_policy_vehicle_exemption(
      license_plate_number: $licensePlateNumber
      license_plate_region: $licensePlateRegion
      begin_at: $beginAt
      vehicle_description: $vehicleDescription
    ) {
      policyVehicleExemption: policy_vehicle_exemption {
        ...policyVehicleExemptionSummaryFragment
      }
    }
  }
  ${policyVehicleExemptionSummaryFragment}
`;

export interface StartVehicleExemptionVars {
  licensePlateNumber: string;
  licensePlateRegion: string;
  beginAt: Date;
  vehicleDescription?: string;
}

export interface StartVehicleExemptionData {
  startPolicyVehicleExemption: {
    policyVehicleExemption: PolicyVehicleExemptionSummary;
  };
}

export default START_VEHICLE_EXEMPTION;
